import { useStore } from "../store";
import { updateInfo } from "../info";
import { InputContainer } from "./InputContainer";
import { HorizontalSettingContainer } from "./HorizontalSettingContainer";
import { SettingTitle } from "./SettingTitle";
import { SettingText } from "./SettingText";
import { AnimeImage } from "./AnimeImage";
import { NoImage } from "./NoImage";

const inputStyle = {
  display: "none"
};

export function AnimeImageSettings(props) {
  const { anime } = useStore();

  function compressImage(imageUrl, targetPixels) {
    return new Promise(resolve => {
      const image = new Image();
      image.src = imageUrl;
      image.onload = () => {
        let { width, height } = image;
        if (width > height && width > targetPixels) {
          height = Math.round(height / (width / targetPixels));
          width = targetPixels;
        } else if (width < height && height > targetPixels) {
          width = Math.round(width / (height / targetPixels));
          height = targetPixels;
        }

        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, width, height);
        canvas.toBlob(resolve, "image/jpeg");
      };
    });
  }

  function onImageSelect(e, type) {
    if (e.target.files.length === 0) return;
    const fileReader = new FileReader();
    fileReader.onload = (e) => onImageSave(e, type);
    fileReader.readAsDataURL(e.target.files[0]);
  }

  async function onImageSave(e, type) {
    const compressed = await compressImage(e.target.result, 1000);

    const title = type === "main" ? "메인 이미지" : "썸네일";
    updateInfo(`/anime/${anime.id}/image/${type}`, compressed, title, props.onSave, "POST", {
      "content-type": "application/octet-stream"
    });
  }

  return (<>
    <SettingTitle text="이미지"/>

    <InputContainer> {/* why not reuse when we can? */}
      <HorizontalSettingContainer>
        <SettingText text="메인"/>
        <label htmlFor="main-image">
          {
            props.anime.imageHash ?
              <AnimeImage alt="메인 이미지" src={ `${process.env.REACT_APP_API}/images/${props.anime.imageHash}` }/> :
              <NoImage/>
          }
        </label>
        <input id="main-image" type="file" accept="image/*" style={ inputStyle } onChange={ (e) => onImageSelect(e, "main") }/>
      </HorizontalSettingContainer>

      <HorizontalSettingContainer>
        <SettingText text="썸네일 (소형 이미지)"/>
        <label htmlFor="thumbnail">
          {
            props.anime.smallImageHash ?
              <AnimeImage alt="썸네일" src={ `${process.env.REACT_APP_API}/images/${props.anime.smallImageHash}` }/> :
              <NoImage/>
          }
        </label>
        <input id="thumbnail" type="file" accept="image/*" style={ inputStyle } onChange={ (e) => onImageSelect(e, "thumbnail") }/>
      </HorizontalSettingContainer>
    </InputContainer>
  </>);
}
